'use strict';
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SECONDS = 10;
export const RESULTS_PER_PAGE = 10;
export const API_KEY = '0d606dbb-0fde-4556-95d4-1ecc591466e2';
export const MODAL_CLOSE_SEC = 1.5;
export const RE_RENDER_MODAL_SEC = 1.5;
// all pizza -> https://forkify-api.herokuapp.com/api/v2/recipes?search=4{variety}
// specific recipe -> https://forkify-api.herokuapp.com/api/v2/recipes/{id}
